import React from 'react'
import Line from '../components/Line'
import Footer from '../components/Footer'

const ExperienciePage = () => {
    return (
        <>
            <Line />
            <Footer />
        </>
    )
}

export default ExperienciePage
